import script from "./TraderPlatformHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./TraderPlatformHomeView.vue?vue&type=script&setup=true&lang=js"

import "./TraderPlatformHomeView.vue?vue&type=style&index=0&id=439d8b35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-439d8b35"]])

export default __exports__